import React, { useEffect, useState } from 'react';
import { Box, Typography, Grid, Paper } from '@mui/material';
import './styles/statistics.css'; 

const Statistics = () => {
  const [totalUsers, setTotalUsers] = useState(0);
  const [totalProfiles, setTotalProfiles] = useState(0);
  const [totalConversations, setTotalConversations] = useState(0);

  useEffect(() => {
    // Fetch statistics data from API
    // Replace the following dummy data with actual API calls
    setTotalUsers(150); // Example: setTotalUsers(await fetchTotalUsers());
    setTotalProfiles(300); // Example: setTotalProfiles(await fetchTotalProfiles());
    setTotalConversations(1200); // Example: setTotalConversations(await fetchTotalConversations());
  }, []);

  return (
    <Box className="statistics-container">
      <Typography variant="h4" gutterBottom>
        Statistics
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={4}>
          <Paper className="stat-card">
            <Typography variant="h6">Total Users</Typography>
            <Typography variant="h4">{totalUsers}</Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Paper className="stat-card">
            <Typography variant="h6">Total Profiles</Typography>
            <Typography variant="h4">{totalProfiles}</Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Paper className="stat-card">
            <Typography variant="h6">Total Conversations</Typography>
            <Typography variant="h4">{totalConversations}</Typography>
          </Paper>
        </Grid>
      </Grid>
      {/* Insert more charts, graphs, or any other stats UI here */}
    </Box>
  );
};

export default Statistics;
